export const calculateTimeRemaining = (endDate) => {
  const now = new Date().getTime();
  const end = new Date(endDate).getTime();
  const distance = end - now;

  if (distance < 0) {
    return { expired: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  return { expired: false, days, hours, minutes, seconds };
};

export const getUrgencyLevel = (timeRemaining) => {
  const { days, hours } = timeRemaining;
  const totalHours = days * 24 + hours;

  if (totalHours <= 6) return 'critical';
  if (totalHours <= 24) return 'urgent';
  if (totalHours <= 168) return 'moderate'; // 7 days
  return 'normal';
};

export const formatTimeDisplay = (timeRemaining) => {
  const { days, hours, minutes, seconds } = timeRemaining;
  
  if (days > 0) {
    return `${days}d ${hours}h ${minutes}m`;
  } else if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  } else {
    return `${minutes}m ${seconds}s`;
  }
};
